wbApp.controller('DomainsCtrl', ['$scope', '$modal', '$translate', 'domainsSvc',
function ($scope, $modal, $translate, domainsSvc) {

    function setSelectedDomain(domain, refresh) {
        $scope.selectedDomain = domain;
        $scope.$broadcast('selectedDomainChanged', { domain: domain, refresh: !!refresh });
    }

    $scope.$on('refreshData', function (e, data) {
        $scope.domains = domainsSvc.getAll(true);        
        setSelectedDomain(null);
    });

    $scope.domains = domainsSvc.getAll(true);

    $scope.gridSettings = {
        name: 'domains',
        columns: [
            { dataField: 'name', caption: $translate.instant('TXT_LBL_NAME'), dataType: 'string', width: '270px', sortOrder: 'asc' },
            { dataField: 'description', caption: $translate.instant('TXT_LBL_DESCRIPTION'), dataType: 'string'},
            { dataField: 'reservationTeacherHourSingleRate', caption: $translate.instant('TXT_LBL_PRICE'), dataType: 'number', format: { type: 'currency', precision: 2 }, width: '80px' },
            { dataField: 'reservationTeacherHourGroupOneRate', caption: $translate.instant('TXT_LBL_GRP_ONE_PRICE'), dataType: 'number', format: { type: 'currency', precision: 2 }, width: '80px' },
            { dataField: 'reservationTeacherHourGroupTwoRate', caption: $translate.instant('TXT_LBL_GRP_TWO_PRICE'), dataType: 'number', format: { type: 'currency', precision: 2 }, width: '80px' },
            { dataField: 'disabledForClients', caption: $translate.instant('TXT_DISABLED_FOR_CLIENTS'), dataType: 'boolean', width: '60px' },
        ]
    }

    $scope.onRowSelected = function (data) {
        setSelectedDomain(data);
    }

    $scope.onRowEdit = function (data) {
        detailDialogPromise.$promise.then(function () {
            detailDialogPromise.$scope.model = angular.copy(data);
            detailDialogPromise.show();
        });
    }

    $scope.onRowAdd = function () {
        detailDialogPromise.$promise.then(function () {
            detailDialogPromise.$scope.model = domainsSvc.createNew();
            detailDialogPromise.show();
        });
    }

    $scope.onRowDelete = function (data) {
        domainsSvc.remove(data);
    }

    $scope.tabs = [
    {
        title: 'TXT_DETAIL',
        template: "reservations/domains/domains-detail-tabs/detail.html"
    }, {
        title: 'TXT_SPECIALIZATIONS',
        template: "reservations/domains/domains-detail-tabs/specializations.html"
    }];

    $scope.tabs.activeTab = 0;

    $scope.$watch('tabs.activeTab', function (newValue, oldValue) {
        $scope.$broadcast('activeTabChanged', { activeTab: newValue, oldValue: oldValue });
    });

    var detailDialogPromise = $modal({
        templateUrl: 'reservations/domains/detail.html',
        show: false,
        scope: $scope.$new()
    });

}]);
